/**
 * FAQ Accordion Smooth Animation
 * Handles smooth opening and closing animations for FAQ items
 */

class FaqAccordion {
  constructor() {
    // Check if user prefers reduced motion
    this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    this.initAccordions();
  }

  initAccordions() {
    const faqItems = document.querySelectorAll(".faq-item details");

    faqItems.forEach((details) => {
      const summary = details.querySelector("summary");
      const content = details.querySelector(".faq-item__answer");

      if (!summary || !content) return;

      // Prevent default behavior
      summary.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggle(details, summary, content);
      });

      // Set initial state
      if (!details.hasAttribute("open")) {
        content.style.maxHeight = "0";
        content.style.opacity = "0";
      } else {
        // Set appropriate height for open state
        if (this.prefersReducedMotion) {
          content.style.maxHeight = "none";
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
        content.style.opacity = "1";
      }
    });
  }

  toggle(details, summary, content) {
    const isOpen = details.hasAttribute("open");

    // If user prefers reduced motion, use instant toggle
    if (this.prefersReducedMotion) {
      if (isOpen) {
        details.removeAttribute("open");
        summary.setAttribute("aria-expanded", "false");
        content.style.maxHeight = "0";
        content.style.opacity = "0";
      } else {
        details.setAttribute("open", "");
        summary.setAttribute("aria-expanded", "true");
        content.style.maxHeight = "none";
        content.style.opacity = "1";
      }
      return;
    }

    if (isOpen) {
      // Closing animation
      this.close(details, content);
    } else {
      // Opening animation
      this.open(details, summary, content);
    }
  }

  open(details, summary, content) {
    // Set the open attribute
    details.setAttribute("open", "");
    summary.setAttribute("aria-expanded", "true");

    // Get the scroll height
    const scrollHeight = content.scrollHeight;

    // Animate opening
    requestAnimationFrame(() => {
      content.style.maxHeight = scrollHeight + "px";
      content.style.opacity = "1";
    });

    // After animation completes, set max-height to none for dynamic content
    content.addEventListener("transitionend", function onTransitionEnd() {
      content.removeEventListener("transitionend", onTransitionEnd);
      if (details.hasAttribute("open")) {
        content.style.maxHeight = "none";
      }
    });
  }

  close(details, content) {
    // Set explicit height before closing
    const scrollHeight = content.scrollHeight;
    content.style.maxHeight = scrollHeight + "px";

    // Force reflow
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.style.maxHeight = "0";
        content.style.opacity = "0";
      });
    });

    // Remove open attribute after animation
    content.addEventListener("transitionend", function onTransitionEnd(e) {
      if (e.propertyName === "max-height") {
        content.removeEventListener("transitionend", onTransitionEnd);
        details.removeAttribute("open");
        details.querySelector("summary").setAttribute("aria-expanded", "false");
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new FaqAccordion();
  });
} else {
  new FaqAccordion();
}

// Re-initialize on Shopify section editor changes
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    new FaqAccordion();
  });
}
